export default {
  drawerTitle: 'Create coupon batch',
  businessType: 'Business Type',
  businessTypeGeneral: 'General Voucher',
  businessTypeCps: 'Affiliate Voucher',
  contentbatch1: 'Please select a voucher template',
  contentbatch2: 'Voucher display name',
  contentbatch3: 'Order needs to reach',
  contentbatch4: 'Voucher Amount',
  contentbatch5: 'Usage period',
  contentbatch6: 'Validity after receipt',
  contentbatch7: 'day',
  contentbatch8: 'Limit Type',
  contentbatch9: 'select or enter the specified category or product ID',
  contentbatch10: 'Quantity of issues',
  contentbatch11: 'Piece',
  contentbatch12: 'Release Option',
  contentbatch13: 'After creation, it will be published to the voucher center and store homepage',
  contentbatch12Option_1: 'Public (voucher center and store home)',
  contentbatch12Option_2: 'Private (invisible, send to customer VIA talking)',
  contentbatch12OptionCps: 'Affiliate Link',
  classId: 'Please select product categories, multiple selections are supported.',
  classId2: 'Input the ListingID collection, separated by commas.',
  types1: 'For All Products',
  types2: 'Customize category Voucher',
  types3: 'Product-specific Voucher',
  moreThan: 'Greater than ',
  lessThan: 'Less than ',
  warning1: 'The information is incomplete.',
  warning2: '达到购物额',
  warning3: '达到购物额不能低于',
  warning4: '券面额',
  warning5: '券面额不能高于',
  warning6: '领取后有效期',
  warning7: '领取后有效期要大于0',
  warning8: '发行数',
  warning9: '券面额必须小于购物达到',
  warning10: '请使用英文逗号隔开',
  warning11: '不能以逗号结尾',
  confirmTitle: '创建后不能取消，只能做失效处理，您确定吗',
  warning12: '必须为整数',
  forStore: 'For Store',
  selectCategory: 'Select Categories'
}
